import type { ReactNode } from "react";
import { Icon } from "./Icon.js";

export interface ModalProps {
  children: ReactNode;
  title?: string;
  onClose: () => void;
}

export function Modal({ children, title, onClose }: ModalProps) {
  return (
    <div className="modal-scrim" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div
          className="row-between"
          style={{ marginBottom: title ? 16 : 0, alignItems: "flex-start" }}
        >
          {title ? <h3>{title}</h3> : <span />}
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            style={{
              padding: 4,
              borderRadius: 999,
              color: "var(--ink-soft)",
              display: "inline-flex",
            }}
          >
            <Icon name="close" size={20} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
